module.exports = __webpack_public_path__ + "img/bg-banner.050aeb0c.png";